import React, { useState, useEffect } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Form, InputPicker, Schema, DatePicker } from 'rsuite';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import { getStates } from '../../../../../services/Shared/codeTable.service'
import Information from '../../../../Shared/Card/Information';
import eiApplicationService from '../../../../../services/Internal/Application/EI/eiApplication.service';
import applicationService from '../../../../../services/Internal/Application/application.service';
import examinationService from '../../../../../services/Internal/Application/EI/examination.service'
import { GetAppInformationContent } from '../../../../Shared/InformationContent/EiInformation';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Issues from '../../../../Shared/Card/Issues';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function ExaminationVerification() {
    const [states, setStates] = useState([])
    const routes = useSelector(x => x.currentRoutes);
    const appId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const sectionId = 11;
    const [formModel, setFormModel] = useState({
        id: 0,
        applicationId: appId,
        entityId: entityId,
        jurisdictionState: null,
        dateOfExam: null,
        userCrte: "",
        dateCrte: new Date(),
        deleted: false
    });
    const [sectionData, setSectionData] = useState({});
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineer Intern Application",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Examination"
        }
    );
    const [hasLoaded, setHasLoaded] = useState(false);
    const push = useNavigate();
    const { DateType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        jurisdictionState: ObjectType().isRequired('This field is required.'),
        dateOfExam: DateType('Please enter a valid date.').isRequired('This field is required.')
    });
    useEffect(() => {
        getStates().then(setStates);
        examinationService.getExamination(appId).then((response) => {
            if (response.data) {
                setFormModel({
                    ...response.data,
                    dateOfExam: response.data.dateOfExam != null ? new Date(response.data.dateOfExam) : null
                });
            }
            eiApplicationService.eiGetSection(appId, sectionId).then((data) => {
                setSectionData(data.data);
                setIsComplete(data.data.staffReviewComplete)
                applicationService.getIndividualApplication(appId).then((appData) => {
                    setIsUserEditable(appData.data.status.id == 2)
                    entityService.getEntity(response.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: appData.data?.credential?.formattedLicenseNumber,
                                applicationDate: appData.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                })
            })
        })
    }, [])
    const formSubmit = (validation, event) => {
        examinationService.postExamination(formModel).then((response) => {
            eiApplicationService.eiMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
                if (response.data && data.data) {
                    nextSectionNavigation();
                }
            })
        })

    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <Container fluid>
            <FormEntityInformation {...entityInfo} />
            <Information content={GetAppInformationContent("exam")} />
            <br />
            {hasLoaded ?
                <Form readOnly={!isUserEditable} fluid model={model} formValue={formModel} onChange={setFormModel} onSubmit={formSubmit}>
                    <Card className="mb-3">
                        <Card.Header>
                            Fundamentals Exam (FE)
                        </Card.Header>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col sm={3}>
                                    <Form.ControlLabel>Jurisdiction</Form.ControlLabel>
                                </Col>
                                <Col>
                                    <Form.Control
                                        accepter={InputPicker}
                                        placeholder="Please Select"
                                        block
                                        data={states}
                                        name="jurisdictionState"
                                        searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>Date (mm/dd/yyyy)</Form.ControlLabel>
                                </Col>
                                <Col>
                                    <Form.Control
                                        accepter={DatePicker}
                                        oneTap
                                        format="MM/dd/yyyy"
                                        block
                                        name="dateOfExam"
                                        placeholder=" "
                                    >
                                    </Form.Control>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Issues isUserEditable={isUserEditable} isInternal={true} type={1} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                    <FormActionButtons
                        isReadOnly={!isUserEditable}
                        nextSectionCallback={nextSectionNavigation}
                        isUserEditable={isUserEditable}
                        showSectionComplete={true}
                        isComplete={isComplete}
                        isCompleteCallback={setIsComplete}
                        backToSectionLink="/internal/eiapp/sections" />
                </Form>
                : <LoadingSpinner />
            }
        </Container>
    );
}
export default ExaminationVerification